import React from "react";

function NakiNigunAlbumUnavailableInAppTemplate() {
    return (
        <p className="u-type--sml u-type--color--warning--light">This album is not available in mobile application</p>
    );
}

export default NakiNigunAlbumUnavailableInAppTemplate;
